/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type LoginPageLotInfoVariables = Types.Exact<{
  lotId: Types.Scalars['Int']
}>

export type LoginPageLotInfo = {
  __typename: 'Query'
  lot: {
    __typename: 'Lot'
    id: number
    name: string
    subscribed: boolean
    creditForSubscriptions: {
      __typename: 'Money'
      cents: number
      formatted: string
    } | null
  } | null
}

export const LoginPageLotInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LoginPageLotInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lotId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lotId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditForSubscriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useLoginPageLotInfo__
 *
 * To run a query within a React component, call `useLoginPageLotInfo` and pass it any options that fit your needs.
 * When your component renders, `useLoginPageLotInfo` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginPageLotInfo({
 *   variables: {
 *      lotId: // value for 'lotId'
 *   },
 * });
 */
export function useLoginPageLotInfo(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LoginPageLotInfo,
    LoginPageLotInfoVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<LoginPageLotInfo, LoginPageLotInfoVariables>(
    LoginPageLotInfoDocument,
    options
  )
}
export function useLoginPageLotInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LoginPageLotInfo,
    LoginPageLotInfoVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LoginPageLotInfo,
    LoginPageLotInfoVariables
  >(LoginPageLotInfoDocument, options)
}
export type LoginPageLotInfoHookResult = ReturnType<typeof useLoginPageLotInfo>
export type LoginPageLotInfoLazyQueryHookResult = ReturnType<
  typeof useLoginPageLotInfoLazyQuery
>
export type LoginPageLotInfoQueryResult = Apollo.QueryResult<
  LoginPageLotInfo,
  LoginPageLotInfoVariables
>
